module.exports = __webpack_public_path__ + "static/img/home_new.bfd480e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_new.png
// module id = ueaE
// module chunks = 0